import {
  GET_PROFILE_FAIL,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  SET_PROFILE_MEASUREMENT_FORMAT
} from './action';
import * as queries from './queries';

export function fetchMyProfile(kaercherUserId) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: GET_PROFILE_REQUEST });
      const clientResponse = await client.query({
        query: queries.fetchMyProfile,
        variables: { kaercherUserId }
      });
      const result = clientResponse?.data?.getMyProfile;
      dispatch({ type: GET_PROFILE_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: GET_PROFILE_FAIL });
    }
  };
}

export function setProfileMeasurementFormat(measurementFormat) {
  return { type: SET_PROFILE_MEASUREMENT_FORMAT, payload: measurementFormat };
}
